import { inr, short } from "../../utils/helpers";

export default function TemplateCard({ template, selected, onSelect }) {
  return (
    <button onClick={() => onSelect(template)} className={`tap glass w-full rounded-app p-4 text-left ${selected ? "ring-2 ring-violet-500" : ""}`}>
      <div className="flex justify-between gap-3"><h3 className="font-bold">{template.name}</h3><span className="text-xs text-tg-hint">{template.is_free ? "Free" : inr(template.price)}</span></div>
      <p className="mt-2 text-sm text-tg-hint">{short(template.description, 90)}</p>
      <div className="mt-3 flex gap-2 text-xs">{(template.tags || []).slice(0, 3).map((tag) => <span key={tag} className="rounded-full bg-white/10 px-2 py-1">{tag}</span>)}</div>
    </button>
  );
}
